<template>
  <h4
    :class="`size-${size}`"
  >
    <slot />
  </h4>
</template>

<script>
  export default {
    props: {
      size: { type: String, default: 'md' }
    }
  }
</script>

<style scoped lang="scss">
  @import "~@/assets/sass/variables";

  h4 {
    text-align: left;

    &.size-md { font-size: 1.75rem }
    &.size-sm { font-size: 1rem }
    &.size-xs { font-size: 1rem }

    b, strong { 
      font-weight: 700;
    }
  }
</style>